<template>
	<div class="skeleton-container quill-question unanswered">
		<div class="skeleton-question"></div>
		<div class="skeleton-answer"></div>
	</div>
</template>

<script>
export default {
	name: 'SkeletonLoader',
};
</script>

<style>
.skeleton-container {
	display: flex;
	flex-direction: column;
	gap: 10px;
	width: 100%;
}

.skeleton-gradient,
.skeleton-question,
.skeleton-answer {
	background: linear-gradient(
		90deg,
		rgba(150, 150, 150, 0.1) 25%,
		rgba(100, 100, 100, 0.3) 50%,
		rgba(150, 150, 150, 0.1) 75%
	);
	background-size: 200% 100%;
	animation: loading 1.5s infinite;
	border-radius: 4px;
}

.skeleton-question {
	height: 36px;
	width: 335px;
}

.skeleton-answer {
	height: 51px;
	width: 521px;
}

@media (max-width: 992px) {
	.skeleton-question {
		height: 30px;
		width: 280px;
	}

	.skeleton-answer {
		width: 456px;
	}
}

@media (max-width: 576px) {
	.skeleton-question {
		height: 30px;
		width: 280px;
	}

	.skeleton-answer {
		width: 327px;
	}
}

@keyframes loading {
	0% {
		background-position: 200% 0;
	}
	100% {
		background-position: -200% 0;
	}
}

.waffle.page-context form:not(.non-scrollable) .quill-question:nth-child(n+2 of .quill-question:not(.grouped)) {
  margin-top: calc(15em - 20px) !important;
  scroll-margin: 13em !important;
  @media only screen and (max-width: 990px) {
    scroll-margin: 14em !important;
  }
}
</style>
